import script from "./BankInfoDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./BankInfoDetail.vue?vue&type=script&setup=true&lang=ts"

import "./BankInfoDetail.vue?vue&type=style&index=0&id=e300a790&lang=css"

const __exports__ = script;

export default __exports__